import {
  type LoginRequest,
  type LoginResponse,
  LoginResponseSchema,
  type SessionResponse,
  SessionResponseSchema,
} from '@invoice/shared/schemas';
import {
  type UseMutationResult,
  type UseQueryResult,
  useMutation,
  useQuery,
} from '@tanstack/react-query';

import { apiFetch } from '../api';

export async function login(input: LoginRequest): Promise<LoginResponse> {
  return apiFetch('/auth/login', {
    method: 'POST',
    json: input,
    schema: LoginResponseSchema,
  });
}

export function useLogin(): UseMutationResult<LoginResponse, Error, LoginRequest> {
  return useMutation({
    mutationFn: login,
  });
}

export const AUTH_SESSION_KEY = ['auth', 'session'] as const;

export async function fetchSession(signal?: AbortSignal): Promise<SessionResponse> {
  return apiFetch('/auth/session', {
    schema: SessionResponseSchema,
    ...(signal ? { signal } : {}),
  });
}

export function useSession(): UseQueryResult<SessionResponse, Error> {
  return useQuery({
    queryKey: AUTH_SESSION_KEY,
    queryFn: ({ signal }) => fetchSession(signal),
    staleTime: 5 * 60_000,
  });
}

export async function logout(): Promise<{ ok: true }> {
  return apiFetch('/auth/logout', {
    method: 'POST',
  }) as Promise<{ ok: true }>;
}
